import React, { useState, useEffect, useCallback } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Container } from 'reactstrap'
import NAV from '../nav'
import { Header } from 'admin-console-common'
import { Auth } from 'aws-amplify'
import { useUserContext } from '../hooks/useUser'
import { useTranslation } from 'react-i18next'

const Layout = () => {
  const [nav, setNav] = useState(NAV)
  const { user } = useUserContext()
  const { t, i18n } = useTranslation(['portal'])
  const location = useLocation()
  const navigate = useNavigate()

  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
    setNav(getNav(user?.attributes['custom:entity']))
  }

  const logout = () => {
    Auth.signOut()
      .then(() => {
        navigate('/login')
      })
      .catch(error => console.log('error signing out: ', error))
  }

  const getNav = useCallback(
    entity => {
      let _nav = []
      const _NAV = JSON.parse(JSON.stringify(NAV))

      for (let i = 0; i < _NAV.length; i++) {
        _NAV[i].name = t(NAV[i].name)
      }

      for (let item in _NAV) {
        const split = _NAV[item].access.split(' ')
        for (let key in split) {
          if (split[key] === entity) {
            _nav.push(_NAV[item])
          }
        }
      }

      return _nav
    },
    [t]
  )

  useEffect(() => {
    const checkAccess = () => {
      try {
        if (user && user?.attributes) {
          setNav(getNav(user.attributes['custom:entity']))
        } else {
          navigate('/login')
        }
      } catch (error) {
        console.log('error get current session', error)
        navigate('/login')
      }
    }
    checkAccess()
  }, [navigate, getNav, user])

  useEffect(() => {
    if (location.pathname === '/') {
      if (
        user?.attributes['custom:entity'] === 'ADMIN_RBU' ||
        user?.attributes['custom:entity'] === 'ADMIN_DEALER'
      ) {
        navigate('/members', { replace: true })
      } else navigate('/portals', { replace: true })
    }
  }, [location, navigate, user])

  return (
    <div className="app">
      <Header
        user={user}
        logout={logout}
        nav={nav}
        logoRedirectTo={() => navigate('/')}
        userRedirectTo={() => navigate('/profile')}
        changeLanguage={changeLanguage}
      />
      <div className="app-body">
        <main className="main">
          <Outlet />
        </main>
      </div>
      {user && user?.attributes['custom:entity'] === 'ADMIN' && (
        <Container fluid>
          <div className="version text-right">
            {sessionStorage.getItem('version')}
          </div>
        </Container>
      )}
    </div>
  )
}

export default Layout
